export const translations = {
  id: {
    nav_test: "Tes MBTI",
    nav_dashboard: "Dasbor Trainer",
    nav_admin: "Semua Peserta",
    admin: "Admin",
    nav_login: "Masuk",
    nav_logout: "Keluar",
    nav_register: "Daftar",

    hero_tag: "amt consulting · assessment",
    hero_title: "Temukan Tipe Kepribadian MBTI Anda",
    hero_sub:
      "Asesmen MBTI 32 pertanyaan dwibahasa dengan analisis bertenaga AI, disesuaikan untuk generasi Anda. Untuk individu, tim, dan pelatihan korporat.",
    hero_cta: "Mulai Tes Gratis",
    hero_cta2: "Masuk sebagai Trainer",
    feat_1_t: "Dwibahasa ID/EN",
    feat_1_d: "Ikuti tes dalam Bahasa Indonesia atau Inggris.",
    feat_2_t: "Analisis AI",
    feat_2_d: "Hasil mendalam yang dihasilkan Claude Sonnet 4.5.",
    feat_3_t: "Sesi Kelompok",
    feat_3_d: "Undang peserta lewat kode & QR untuk pelatihan.",
    feat_4_t: "Ekspor PDF",
    feat_4_d: "Unduh laporan kepribadian profesional Anda.",

    // test
    setup_title: "Sebelum Mulai",
    setup_sub: "Isi detail Anda dan pilih preferensi tes.",
    label_name: "Nama Lengkap",
    label_email: "Email (opsional)",
    label_language: "Bahasa Tes",
    label_generation: "Generasi Anda",
    start_test: "Mulai Asesmen",
    question: "Pertanyaan",
    of: "dari",
    prev: "Sebelumnya",
    submitting: "Menganalisis kepribadian Anda...",
    please_wait: "Mohon tunggu, AI sedang menyusun laporan Anda.",

    // result
    your_type: "Tipe Anda",
    dimensions: "Dimensi Kepribadian",
    summary: "Ringkasan",
    strengths: "Kekuatan",
    weaknesses: "Kelemahan",
    careers: "Karier yang Cocok",
    partners: "Pasangan yang Cocok",
    famous: "Tokoh Terkenal",
    download_pdf: "Unduh PDF",
    retake: "Ikuti Lagi",

    // auth
    login_title: "Selamat Datang Kembali",
    login_sub: "Masuk ke akun AMT Consulting Anda.",
    register_title: "Buat Akun",
    register_sub: "Daftar untuk menyimpan hasil dan mengelola sesi.",
    password: "Kata Sandi",
    account_type: "Jenis Akun",
    participant: "Peserta",
    trainer: "Trainer",
    trainer_domain_note: "Akun dengan email @amtconsulting.id otomatis menjadi Trainer.",
    google_login: "Lanjutkan dengan Google",
    no_account: "Belum punya akun?",
    have_account: "Sudah punya akun?",

    // dashboard
    dash_title: "Dasbor Trainer",
    dash_sub: "Kelola sesi kelompok dan pantau hasil peserta.",
    create_session: "Buat Sesi",
    session_title: "Judul Sesi",
    no_sessions: "Belum ada sesi. Buat sesi pertama Anda.",
    participants: "Peserta",
    view_results: "Lihat Hasil",
    show_qr: "QR & Undang",
    join_code: "Kode Gabung",
    scan_qr: "Pindai untuk bergabung",
    distribution: "Distribusi Tipe",
    no_participants: "Belum ada peserta yang menyelesaikan tes.",

    // join
    join_title: "Bergabung ke Sesi",
    join_sub: "Anda diundang untuk mengikuti asesmen MBTI.",
    join_start: "Mulai Asesmen",
    invalid_session: "Sesi tidak ditemukan.",

    admin_title: "Semua Peserta",
    admin_sub: "Seluruh hasil asesmen dari semua peserta.",
    search_placeholder: "Cari nama, email, atau tipe...",
    all_types: "Semua Tipe",
    all_gens: "Semua Generasi",
    th_name: "Nama",
    th_email: "Email",
    th_type: "Tipe",
    th_generation: "Generasi",
    th_session: "Sesi",
    th_date: "Tanggal",
    total_participants: "Total Peserta",
    no_results_found: "Tidak ada hasil yang cocok.",
    direct_test: "Langsung (tanpa sesi)",
    export_csv: "Ekspor CSV",
  },
  en: {
    nav_test: "MBTI Test",
    nav_dashboard: "Trainer Dashboard",
    nav_admin: "All Participants",
    admin: "Admin",
    nav_login: "Sign In",
    nav_logout: "Sign Out",
    nav_register: "Sign Up",

    hero_tag: "amt consulting · assessment",
    hero_title: "Discover Your MBTI Personality Type",
    hero_sub:
      "A bilingual 32-question MBTI assessment with AI-powered analysis, tailored to your generation. For individuals, teams, and corporate training.",
    hero_cta: "Take the Free Test",
    hero_cta2: "Sign in as Trainer",
    feat_1_t: "Bilingual ID/EN",
    feat_1_d: "Take the test in Indonesian or English.",
    feat_2_t: "AI Analysis",
    feat_2_d: "Deep results generated by Claude Sonnet 4.5.",
    feat_3_t: "Group Sessions",
    feat_3_d: "Invite participants via code & QR for training.",
    feat_4_t: "PDF Export",
    feat_4_d: "Download your professional personality report.",

    setup_title: "Before You Begin",
    setup_sub: "Fill in your details and choose your test preferences.",
    label_name: "Full Name",
    label_email: "Email (optional)",
    label_language: "Test Language",
    label_generation: "Your Generation",
    start_test: "Start Assessment",
    question: "Question",
    of: "of",
    prev: "Previous",
    submitting: "Analyzing your personality...",
    please_wait: "Please wait, the AI is crafting your report.",

    your_type: "Your Type",
    dimensions: "Personality Dimensions",
    summary: "Summary",
    strengths: "Strengths",
    weaknesses: "Weaknesses",
    careers: "Suitable Careers",
    partners: "Compatible Partners",
    famous: "Famous People",
    download_pdf: "Download PDF",
    retake: "Retake",

    login_title: "Welcome Back",
    login_sub: "Sign in to your AMT Consulting account.",
    register_title: "Create Account",
    register_sub: "Sign up to save results and manage sessions.",
    password: "Password",
    account_type: "Account Type",
    participant: "Participant",
    trainer: "Trainer",
    trainer_domain_note: "Accounts with an @amtconsulting.id email automatically become Trainers.",
    google_login: "Continue with Google",
    no_account: "Don't have an account?",
    have_account: "Already have an account?",

    dash_title: "Trainer Dashboard",
    dash_sub: "Manage group sessions and monitor participant results.",
    create_session: "Create Session",
    session_title: "Session Title",
    no_sessions: "No sessions yet. Create your first one.",
    participants: "Participants",
    view_results: "View Results",
    show_qr: "QR & Invite",
    join_code: "Join Code",
    scan_qr: "Scan to join",
    distribution: "Type Distribution",
    no_participants: "No participants have completed the test yet.",

    join_title: "Join Session",
    join_sub: "You've been invited to take the MBTI assessment.",
    join_start: "Start Assessment",
    invalid_session: "Session not found.",

    admin_title: "All Participants",
    admin_sub: "Every assessment result from all participants.",
    search_placeholder: "Search name, email, or type...",
    all_types: "All Types",
    all_gens: "All Generations",
    th_name: "Name",
    th_email: "Email",
    th_type: "Type",
    th_generation: "Generation",
    th_session: "Session",
    th_date: "Date",
    total_participants: "Total Participants",
    no_results_found: "No matching results.",
    direct_test: "Direct (no session)",
    export_csv: "Export CSV",
  },
};

export const GEN_LABELS = {
  genx: "Gen X",
  geny: "Gen Y",
  genz: "Gen Z",
  genalpha: "Gen Alpha",
};
